"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepDetails = void 0;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const Button_1 = __importDefault(require("react-bootstrap/Button"));
const Col_1 = __importDefault(require("react-bootstrap/Col"));
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const OverlayTrigger_1 = __importDefault(require("react-bootstrap/OverlayTrigger"));
const Popover_1 = __importDefault(require("react-bootstrap/Popover"));
const Row_1 = __importDefault(require("react-bootstrap/Row"));
const react_markdown_1 = require("react-markdown/lib/react-markdown");
const configContext_1 = require("../../context/configContext");
const Booking_1 = require("../../models/Booking");
const ScrollToTopController_1 = require("../../utils/ScrollToTopController");
const IconChevronLeft_1 = require("../icons/IconChevronLeft");
const IconDvr_1 = require("../icons/IconDvr");
const Spinner_1 = require("../spinner/Spinner");
const ValidationErrors_1 = require("../ValidationErrors");
class ValidationErrorsStepDisplayAndMore extends ValidationErrors_1.ValidationErrors {
    constructor() {
        super(...arguments);
        this.titleInvalid = "";
        this.peopleInvalid = "";
        this.discountCodeInvalid = "";
        this.commentsInvalid = "";
        this.acceptTermsPopup = "";
        this.acceptTermsLink = "";
    }
}
const StepDetails = (props) => {
    const [showErrors, setShowErrors] = (0, react_1.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, react_1.useState)(false);
    const [acceptTermsPopup, setAcceptTermsPopup] = (0, react_1.useState)(false);
    const [acceptTermsLink, setAcceptTermsLink] = (0, react_1.useState)(false);
    const config = (0, configContext_1.useConfig)();
    (0, react_1.useEffect)(() => {
        /** Set org or name as title on initial render if not already set. */
        if (props.booking.title.trim() === "") {
            props.onBookingChange({
                title: props.booking.getContactOrgOrName(),
            });
        }
    }, []);
    function handlePrevious() {
        props.onPrevious();
    }
    function handlePeopleChange(people) {
        const peopleInt = parseInt(people);
        // Keep in min/max range.
        let newPeople;
        if (isNaN(peopleInt)) {
            newPeople = 0;
        }
        else {
            newPeople = Math.min(Math.max(peopleInt, 0), 1000);
        }
        props.onBookingChange({
            people: newPeople,
        });
    }
    async function handleSubmit() {
        if (!showErrors) {
            // User clicked button for the first time. Show validation on next render.
            setShowErrors(true);
        }
        if (!validate().hasErrors()) {
            setIsSubmitting(true);
            await props.onSubmit();
        }
    }
    /**
     * Validates this step.
     */
    function validate() {
        const errors = new ValidationErrorsStepDisplayAndMore();
        if (props.booking.title.trim() === "") {
            errors.titleInvalid = "Bitte Titel angeben.";
        }
        if (props.booking.people < 1) {
            errors.peopleInvalid = "Bitte Anzahl Personen angeben.";
        }
        if (props.discountCode !== "" &&
            !props.booking.hasResourceOrAddonsDiscount()) {
            errors.discountCodeInvalid = "Ungültiger Rabattcode.";
        }
        const comments = props.booking.commentsByCustomer;
        if (comments.split("\n").length > 20) {
            errors.commentsInvalid = `Kommentar enthält mehr als 20 Zeilen (${comments.split("\n").length} Zeilen).`;
        }
        else if (comments.length > 2000) {
            errors.commentsInvalid = `Kommentar enthält mehr als 2000 Zeichen (${comments.length} Zeichen).`;
        }
        // Validate terms popup if enabled.
        if (config.termsPopup && !acceptTermsPopup) {
            errors.acceptTermsPopup = `Bitte akzeptieren`;
        }
        // Validate terms link if enabled.
        if (config.termsLink && !acceptTermsLink) {
            errors.acceptTermsLink = `Bitte akzeptieren`;
        }
        return errors;
    }
    function termsPopup() {
        if (!config.termsPopup) {
            return null;
        }
        return (react_1.default.createElement(Form_1.default.Group, { controlId: "terms-popup", className: "text-right text-nowrap" },
            react_1.default.createElement(Form_1.default.Check, { className: "mr-1", inline: true, type: "checkbox", checked: acceptTermsPopup, onChange: (e) => setAcceptTermsPopup(e.target.checked), isInvalid: showErrors && validationErrors.acceptTermsPopup !== "" }),
            config.termsPopup.pre,
            react_1.default.createElement(OverlayTrigger_1.default, { placement: "left", overlay: react_1.default.createElement(Popover_1.default, { id: "popover-basic" },
                    react_1.default.createElement(Popover_1.default.Title, { as: "h3" }, config.termsPopup.title),
                    react_1.default.createElement(Popover_1.default.Content, null,
                        react_1.default.createElement(react_markdown_1.ReactMarkdown, { children: config.termsPopup.text }))) },
                react_1.default.createElement("a", { href: "#" }, config.termsPopup.title)),
            config.termsPopup.post,
            showErrors && validationErrors.acceptTermsPopup !== "" && (react_1.default.createElement("div", { className: "invalid-feedback d-block" }, validationErrors.acceptTermsPopup))));
    }
    function termsLink() {
        if (!config.termsLink) {
            return null;
        }
        return (react_1.default.createElement(Form_1.default.Group, { controlId: "terms-link", className: "text-right text-nowrap" },
            react_1.default.createElement(Form_1.default.Check, { className: "mr-1", inline: true, type: "checkbox", checked: acceptTermsLink, onChange: (e) => setAcceptTermsLink(e.target.checked) }),
            config.termsLink.pre,
            react_1.default.createElement("a", { href: config.termsLink.link, target: "_blank" }, config.termsLink.title),
            config.termsLink.post,
            showErrors && validationErrors.acceptTermsLink !== "" && (react_1.default.createElement("div", { className: "invalid-feedback d-block" }, validationErrors.acceptTermsLink))));
    }
    const validationErrors = validate();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ScrollToTopController_1.ScrollToTop, null),
        react_1.default.createElement("h3", null, "Anlass"),
        react_1.default.createElement(Form_1.default, { noValidate: true },
            react_1.default.createElement(Row_1.default, null,
                react_1.default.createElement(Col_1.default, { sm: 6, xl: 5, className: "mb-2", style: { marginTop: "5px" } },
                    react_1.default.createElement(react_bootstrap_1.Card, { bg: "secondary", text: "white" },
                        react_1.default.createElement(react_bootstrap_1.Card.Header, null,
                            react_1.default.createElement(IconDvr_1.IconDvr, null),
                            " Beschriftung vor Ort"),
                        react_1.default.createElement(react_bootstrap_1.Card.Body, null,
                            react_1.default.createElement(react_bootstrap_1.Card.Title, { style: { minHeight: 24 } }, props.booking.title),
                            react_1.default.createElement(react_bootstrap_1.Card.Text, { style: { minHeight: 24 } }, props.booking.subtitle || " ")))),
                react_1.default.createElement(Col_1.default, { sm: 6, xl: 7 },
                    react_1.default.createElement(Form_1.default.Group, { controlId: "title" },
                        react_1.default.createElement(Form_1.default.Label, null, "Titel*"),
                        react_1.default.createElement(Form_1.default.Control, { type: "text", placeholder: "Titel", value: props.booking.title, onChange: (e) => {
                                props.onBookingChange({
                                    title: e.target.value.slice(0, Booking_1.Booking.titleMaxLength),
                                });
                            }, isValid: showErrors && validationErrors.titleInvalid === "", isInvalid: showErrors && validationErrors.titleInvalid !== "" }),
                        react_1.default.createElement(Form_1.default.Control.Feedback, { type: "invalid" }, validationErrors.titleInvalid)),
                    react_1.default.createElement(Form_1.default.Group, { controlId: "subtitle" },
                        react_1.default.createElement(Form_1.default.Label, null, "Untertitel"),
                        react_1.default.createElement(Form_1.default.Control, { type: "text", placeholder: "(optional)", value: props.booking.subtitle, onChange: (e) => {
                                props.onBookingChange({
                                    subtitle: e.target.value.slice(0, Booking_1.Booking.subtitleMaxLength),
                                });
                            } })))),
            react_1.default.createElement("h4", { className: "mt-4" }, "Weitere Angaben"),
            react_1.default.createElement(Row_1.default, null,
                react_1.default.createElement(Col_1.default, { sm: 6, xl: 5 },
                    react_1.default.createElement(Form_1.default.Group, { controlId: "people" },
                        react_1.default.createElement(Form_1.default.Label, null, "Anzahl Personen*"),
                        react_1.default.createElement(Form_1.default.Control, { type: "number", value: props.booking.people === 0 ? "" : props.booking.people, onChange: (e) => handlePeopleChange(e.target.value), isValid: showErrors && validationErrors.peopleInvalid === "", isInvalid: showErrors && validationErrors.peopleInvalid !== "" }),
                        react_1.default.createElement(Form_1.default.Control.Feedback, { type: "invalid" }, validationErrors.peopleInvalid))),
                react_1.default.createElement(Col_1.default, { sm: 5, xl: 4, className: "offset-sm-1 offset-xl-3" },
                    react_1.default.createElement(Form_1.default.Group, { controlId: "discount" },
                        react_1.default.createElement(Form_1.default.Label, null, "Rabattcode"),
                        react_1.default.createElement(Form_1.default.Control, { type: "text", value: props.discountCode, placeholder: "(optional)", onChange: (e) => props.onDiscountCodeChange(e.target.value.slice(0, 30)), isValid: props.discountCode !== "" &&
                                validationErrors.discountCodeInvalid === "", isInvalid: showErrors && validationErrors.discountCodeInvalid !== "" }),
                        react_1.default.createElement(Form_1.default.Control.Feedback, { type: "invalid" }, validationErrors.discountCodeInvalid)))),
            react_1.default.createElement(Form_1.default.Group, { controlId: "comments" },
                react_1.default.createElement(Form_1.default.Label, null, "Weitere Anliegen und Bemerkungen"),
                react_1.default.createElement(Form_1.default.Control, { as: "textarea", rows: 4, value: props.booking.commentsByCustomer, onChange: (e) => props.onBookingChange({
                        commentsByCustomer: e.target.value,
                    }), isInvalid: showErrors && validationErrors.commentsInvalid !== "" }),
                react_1.default.createElement(Form_1.default.Control.Feedback, { type: "invalid" }, validationErrors.commentsInvalid)),
            termsPopup(),
            termsLink(),
            react_1.default.createElement(Row_1.default, { className: "mt-4" },
                react_1.default.createElement(Col_1.default, null,
                    react_1.default.createElement(Button_1.default, { variant: "link", onClick: handlePrevious },
                        react_1.default.createElement(IconChevronLeft_1.IconChevronLeft, null),
                        " Zur\u00FCck")),
                react_1.default.createElement(Col_1.default, { className: "text-right" },
                    react_1.default.createElement(Button_1.default, { variant: "success", size: "lg", onClick: handleSubmit, disabled: (showErrors && validationErrors.hasErrors()) || isSubmitting }, isSubmitting ? react_1.default.createElement(Spinner_1.Spinner, null) : "Raum buchen"))))));
};
exports.StepDetails = StepDetails;
